/**
 *
 * Tag
 *
 */

import React from 'react';
import { Tag as CustomTag } from 'antd';
import Icon from '../Icon';
import './style.css';

type TagMapInterface = {
  color: string;
  type: string;
};

type TagMappingInterface = {
  [key: string]: TagMapInterface;
};

const tagMapping: TagMappingInterface = {
  statusOnline: { color: '#21965333', type: 'greenCircle' },
  statusOffline: { color: '#4f4f4f33', type: 'greyCircle' },
  statusIssue: { color: '#ec792b40', type: 'orangeCircle' },
  statusError: { color: '#eb575733', type: 'redCircle' },
};

const Tag = ({ text, type, ...rest }: any) => {
  if (tagMapping[type])
    return (
      <CustomTag
        {...rest}
        color={tagMapping[type].color}
        icon={<Icon type={tagMapping[type].type} size={9} tagIcon />}
      >
        {text || rest.children}
      </CustomTag>
    );
  return <CustomTag {...rest}>{text || rest.children}</CustomTag>;
};

export default Tag;
